module.exports = __webpack_public_path__ + "media/financial_aid/fastweb-student-lending-center_300x150-c750a959.gif";